import request from '@/utils/request'

// 获取字典数据
// GET http://localhost:1012/web/dict/data/type/{dictType}
export function getDict(dictType) {
	return request({
		url: `/web/dict/data/type/${dictType}`,
		method: "get",
	});
}

// 查询申请告知表信息
export function listSqgzb(query) {
    return request({
        url: '/web/sqgzb/list',
        method: 'get',
        params: query
    })
}

// 获取案由信息表信息
export function getAyList(ajType) {
    return request({
      url: '/web/ayxxb/getByType/'+ ajType,
      method: 'get',
    })
}

  // 上传文件
export function upload() {
  return request({
    url: '/web/zjclb/uploadCl',
    method: 'post',
  })
}

export function zcJcZnzyList(query) {
    return request({
        url: '/web/zc/zcJcZnzyList',
        method: 'get',
        params: query
    })
}



export function getCaseBooks(query) {
    return request({
        url: '/web/ws/list',
        method: 'get',
        params:query
    })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
        url: '/web/dict/data/type/' + dictType,
        method: 'get'
    })
}
// /system/dict/data01/type/
// GET http://localhost:1012/web/dict/data/typeSps/{{dictType}}
export function getUpDicts(dictType) {
    return request({
        url: '/web/dict/data/typeSps/' + dictType,
        method: 'get'
    })

}


// GET http://localhost:1012/web/dict/data/typeLdjc/{{dictType}}
export function getJcDicts(dictType) {
    return request({
        url: '/web/dict/data/typeLdjc/' + dictType,
        method: 'get'
    })
}

export function updateCaseBooks(data) {
    return request({
        url: '/web/ws',
        method: 'put',
        data:data
    })
}

// http://localhost:1012/web/count

// 新增案件时 需要往状态表新增一条对应的记录
export function addStatusCount(data) {
    return request({
        url: '/web/count',
        method: 'post',
        data:data
    })
}
export function getStatusCount(data) {
    return request({
        url: '/web/count/'+data,
        method: 'get',
    })
}
export function updateStatusCount(data) {
    return request({
        url: '/web/count',
        method: 'put',
        data:data
    })
}
